const body = document.querySelector('body')
const boxes = document.querySelectorAll('.box');
const box = document.querySelector('.box');
const leaf = document.querySelector('.leaf');
const text = document.querySelector('.landing-animated-image__text');
const volumeUp = document.querySelector('.js-volume-up');
const volumeDown = document.querySelector('.js-volume-down');
const video = document.querySelector('.js-video')
function isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    // Only completely visible elements return true:
    // var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // console.log(elemTop,'elemTop')
    // console.log(window.innerHeight,'window.innerHeight')
    // console.log(elemBottom,'elemBottom')
    let percentage = ((elemTop - window.innerHeight)/(elemTop - elemBottom))
    console.log(percentage, 'percentage')
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return percentage;
}
function isLeafIn(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    // Only completely visible elements return true:
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // console.log(elemTop,'elemTop')
    // console.log(window.innerHeight,'window.innerHeight')
    // console.log(elemBottom,'elemBottom')
    let percentage = ((elemTop - window.innerHeight)/(elemTop - elemBottom))
    console.log(percentage, 'percentage')
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
}
function rotateOnScroll(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    let percentage = ((elemTop - window.innerHeight)/(elemTop - elemBottom))
    console.log(percentage * 20, 'percentage')
    return percentage * 20;
}
body.addEventListener('scroll', () => {
  boxes.forEach(box => {
    const animatedText = box.querySelector('.landing-animated-image__text')
    if (animatedText) {  // Check if animatedText not null
      animatedText.style.opacity = isScrolledIntoView(box)
      if (isScrolledIntoView(box) > 1) {
        animatedText.classList.add('landing-animated-image__text--passed')
      }
    }
  })
  if(leaf && isLeafIn(leaf)) {
    leaf.classList.add('leaf-rotated')
    leaf.style.transform =  'rotate(' + rotateOnScroll(leaf) + 'deg)'
  }
 });
if(volumeUp) {
    volumeUp.addEventListener('click', (e) => {
        video.muted = false
        volumeDown.classList.remove('hidden')
        volumeUp.classList.add('hidden')
    })
}
if(volumeDown) {
    volumeDown.addEventListener('click', (e) => {
        video.muted = true
        volumeDown.classList.add('hidden')
        volumeUp.classList.remove('hidden')
    })
}
